import type { FunctionComponent, ReactElement } from 'react';

import { Icon, type IconName } from '@iconik-io/uad';

import styles from './search_items_drag_label.module.css';

type Props = {
  title: string;
  description: string | ReactElement;
  iconName: IconName;
  isActive?: boolean;
};

const SearchItemsDragLabel: FunctionComponent<Props> = (props) => (
  <div className={props.isActive ? styles.label : styles.label_inactive}>
    <div>
      <div className={styles.title}>{props.title}</div>
      <div className={styles.description}>{props.description}</div>
    </div>
    <div>
      <div className={styles.icon}>
        <Icon name={props.iconName} />
      </div>
    </div>
  </div>
);

export default SearchItemsDragLabel;
